import React, { type ComponentProps } from 'react';
import { StyleSheet } from 'react-native';
import { theme, VStack } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const OrdersListContainer = (props: ComponentProps<typeof VStack>) => {
  const { children, ...restProps } = props;

  return (
    <VStack gap={0} {...restProps} style={[styles.container, restProps.style]}>
      {children}
    </VStack>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    marginTop: theme.spacing['4'],
    marginBottom: theme.spacing['30'],
  },
});
